// extracted by mini-css-extract-plugin
export var infoRow = "_sg-2";
export var labelContainer = "_sg-0";
export var rightInfo = "_sg-1";